<template>
  <div class="stats-panel flex items-center justify-center">
    <div
      v-for="(stat, index) in stats"
      :key="'stat-' + index"
      class="stat-group"
    >
      <div class="stat-item">
        <div class="stat-number">
          {{ stat.display }}<span class="stat-suffix">{{ stat.unit }}</span>
        </div>
        <div class="stat-label">{{ stat.label }}</div>
      </div>
      <div v-if="index < stats.length - 1" class="stat-divider"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatsPanel",
  data() {
    return {
      stats: [
        { target: 290, unit: "M+", label: "实体标签", display: "0" },
        { target: 18, unit: "M+", label: "恶意标签", display: "0" },
        { target: 597, unit: "M+", label: "行为标签", display: "0" },
      ],
    };
  },
  mounted() {
    this.animateStats();
  },
  methods: {
    animateStats() {
      this.stats.forEach((s, i) => {
        const dur = 2200,
          start = performance.now();
        const tick = (now) => {
          const t = Math.min((now - start) / dur, 1);
          const e = 1 - Math.pow(1 - t, 4);
          this.$set(this.stats[i], "display", Math.floor(s.target * e));
          if (t < 1) requestAnimationFrame(tick);
        };
        setTimeout(() => requestAnimationFrame(tick), 400 + i * 200);
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/newhomepage/statsPanel.less";
</style>
